import {BehaviorSubject, delay, filter, repeat, takeUntil, withLatestFrom} from 'rxjs';
import {connector$} from '@/streams/wallet-connect';
import {stepViews, type Step} from './utils';

export const initStep: Step = 'mainMenu';

export const step$ = new BehaviorSubject<Step>(initStep);
export const stepMetaData$ = new BehaviorSubject<HistorySteps>(createDefaultHistorySteps());

export const componentStatus$ = new BehaviorSubject<'' | 'visible' | 'hidden'>('');
const componentUnMount$ = componentStatus$.pipe(filter((componentStatus) => componentStatus !== 'visible'));
const componentMount$ = componentStatus$.pipe(filter((componentStatus) => componentStatus === 'visible'));
const componentDestroy$ = componentStatus$.pipe(filter((componentStatus) => componentStatus === 'hidden'));

componentDestroy$.subscribe(() => {
  const timer = setTimeout(() => {
    clearTimeout(timer);
    step$.next(initStep);
    stepMetaData$.next(createDefaultHistorySteps());
  }, 100);
});

connector$
  .pipe(
    takeUntil(componentUnMount$),
    repeat({
      delay: () => componentMount$,
    })
  )
  .subscribe((connector) => {
    const currentStep = step$.getValue();
    const metadata = stepViews[currentStep]?.meta;
    if (!connector?.address && !metadata?.allowUnConnect) {
      step$.next('mainMenu');
    }
  });

step$
  .pipe(
    withLatestFrom(stepMetaData$),
    filter(([step, historySteps]) => historySteps.steps[historySteps.steps.length - 1] !== step),
    takeUntil(componentUnMount$),
    repeat({
      delay: () => componentMount$,
    })
  )
  .subscribe(([step, historySteps]) => {
    const steps = [...historySteps.steps];
    if (steps.includes(step)) {
      steps.pop();
    } else {
      const lastIndex = steps.length - 1;
      // 已经链接上钱包，移除当前路径
      if (steps[lastIndex] === 'chooseWallet') {
        steps.splice(lastIndex, 1);
      }
      steps.push(step);
    }
    stepMetaData$.next({
      beforeStep: historySteps.step,
      step,
      beforeSteps: historySteps.steps,
      steps,
    });
  });

function createDefaultHistorySteps(): HistorySteps {
  return {
    beforeStep: '',
    step: initStep,
    beforeSteps: [],
    steps: [initStep],
  };
}

interface HistorySteps {
  beforeStep: '' | Step;
  step: Step;
  beforeSteps: Array<Step>;
  steps: Array<Step>;
}
